<template>
  <div>
    <el-image-viewer
      v-if="visible"
      :on-close="closeViewer"
      :url-list="urlList"
      :z-index="3000"
    />
  </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  name: "imageView",
  components: {ElImageViewer},
  methods: {
    closeViewer() {
      this.visible = false;
    },
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-image-viewer__close{
  color:white;
}
</style>
